import styled from "styled-components";

export const Body = styled.div`
  padding: 4px 18px 8px;
  overflow-y: auto;
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const EmptyMessage = styled.div`
  font-size: 13.5px;
  color: ${(p) => p.theme.tokens.colors.muted};
  padding: 8px 0 16px;
  line-height: 1.4;
`;

export const AddressRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 13px 2px;
  border-bottom: 1px solid ${(p) => p.theme.tokens.colors.softBg};
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }
`;

export const AddressInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const AddressTitle = styled.div`
  font-weight: 800;
  font-size: 14.5px;
  color: ${(p) => p.theme.tokens.colors.ink};
`;

export const AddressSub = styled.div`
  font-size: 12px;
  color: ${(p) => p.theme.tokens.colors.muted};
  margin-top: 1px;
`;

export const RemoveButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 999px;
  border: none;
  background: #fbeae7;
  color: #c0392b;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
`;

export const EditButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 999px;
  border: none;
  background: ${(p) => p.theme.tokens.colors.softTeal};
  color: ${(p) => p.theme.tokens.colors.teal};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
`;

export const Footer = styled.div`
  padding: 12px 18px calc(16px + env(safe-area-inset-bottom));
`;
